<template>
  <aside>
    <!--导航菜单-->
    <el-menu
      :default-active="$route.Url"
      class="el-menu-vertical-demo" :class="{'collapse':isCollapse}"
      @open="handleopen"
      @close="handleclose"
      @select="handleselect"
      unique-opened
      :router="false"
      :collapse="isCollapse"
    >
      <template v-for="(item,index) in menuList">
        <template v-if="!item.hidden">
          <el-submenu :index="index+''" v-if="item.children && item.children.length>0" :key="index" popper-class="pop-submenu">
            <template slot="title" v-if="isCollapse">
              <i :class="item.IconName" class="el-submenu__icon iconfont"></i>
              <span class="el-submenu__text">{{item.PermissionName || item.name}}</span>
            </template>
            <template v-else>
              <i :class="item.IconName" class="iconfont"></i>
              <span slot="title">{{item.PermissionName || item.name}}</span>
            </template>
            <template v-for="(child,index) in item.children">
              <el-menu-item
                :index="child.Url"
                :key="`${child.Url}_${index}`"
                v-if="!child.hidden"
              >{{child.PermissionName || child.name}}</el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item v-else :key="index" :index="item.Url" class="el-submenu__title">
            <template v-if="isCollapse">
              <i class="iconfont el-submenu__icon" :class="item.IconName"></i>
              <span class="el-submenu__text">{{item.PermissionName || item.name}}</span>
            </template>
            <template v-else>
              <span slot="title">{{item.PermissionName || item.name}}</span>
            </template>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
    <!-- <i class="el-icon" :class="{'el-icon-s-unfold':isCollapse,'el-icon-s-fold':!isCollapse}" @click="toggleClick"></i> -->
  </aside>
</template>

<script>
// import menus from '@/data/menus/index.js'
import { openNavUrl } from '@/utils'
export default {
  name: 'yblMenuMini',
  data () {
    return {
      isCollapse: true,
      menuList: [],
      url: ''
    }
  },
  created () {
    /* let data = menus
    this.menuList = JSON.parse(JSON.stringify(data)).filter(item => {
      return item.children.length > 0 && item
    }) */
    // this.menuList = menus
    let {url} = this.$route.query
    this.url = url
    this.getAuthorization().then(data => {
      return this.loginCustomer(data)
    })
  },
  computed: {
  },
  methods: {
    handleopen () {
      console.log('handleopen')
    },
    handleclose () {
      console.log('handleclose')
    },
    handleselect: function (a, b) {
      console.log(a, b)
      if (a) {
        openNavUrl(a, '', this.url)
      }
    },
    toggleClick () {
      this.isCollapse = !this.isCollapse
    },
    loginCustomer (menus) {
      return this.$store.dispatch('customerLoginCustomer').then(({data}) => {
        console.log(data)
        let roles = data.RoleAuthorization && data.RoleAuthorization.split(',').map(item => +item)
        if (!data.RoleAuthorization || roles.includes(1)) {
          this.menuList = menus
        } else {
          this.menuList = menus.filter(item => roles.includes(+item.PermissionCode))
        }
        console.log(this.menuList)
        return data
      })
    },
    getAuthorization () {
      return this.$store.dispatch('customerGetAuthorization').then(data => {
        console.log(data)
        let menus = data.datas.filter(item => +item.ParentCode === 17)
        // let child = data.datas.filter(item => +item.PermissionType === 2)
        menus = menus.map(item => ({
          ...item,
          children: data.datas.filter(child => child.ParentCode === item.PermissionCode)
        }))
        console.log(menus)
        return menus
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/less/color.less';
@border-color:#e6e6e6;
aside {
  .el-menu {
    height: 100%;
    overflow: auto;
    &.collapse{
      overflow: hidden;
    }
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 230px;
    min-height: 400px;
  }
  .el-icon{
    position: absolute;
    bottom: 10px;
    left:20px;
    cursor: pointer;
  }
  .el-submenu,.el-menu-item{
    border-bottom: 1px solid @border-color;
    i{
      font-style:inherit;
    }
  }
  .el-submenu{
    &__title{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 5px 0 !important;
      background-color: @color;
      color: #FFF;
      line-height: 26px;
      &.is-active{
        color: blue;
        background-color: #ecf5ff;
      }
      &:hover{
        color: blue;
        .el-submenu__icon{
          color:blue;
        }
      }
    }
    &__icon{
      color: #FFF;
      font-size: 23px;
    }
  }
  .el-submenu__text{
    height: auto !important;
    width: auto !important;
    overflow: hidden;
    visibility: visible !important;
    display: inline-block;
    line-height: 26px;
    font-size: 12px;
  }
  .el-menu-item{
    display: flex;
    flex-direction: column;
    line-height: 26px;
    justify-content: center;
    align-items: center;
  }
}
.pop-submenu {
  .el-menu-item{
    height: 40px;
    line-height: 40px;
    &+.el-menu-item{
      border-top: 1px solid @border-color;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SideBarMini.vue